module.exports = __webpack_public_path__ + "img/timmy-01.85ef3abb.png";